export const sizeUnits = ['px', 'rem', 'em', '%'];
